export default (context, inject) => {
  if(process.client) {
    // const openInNewTab = (url) => window.open(url, '_blank', 'noreferrer')
    const openNewUrl = (url) => window.open(url, '_self')
    // Inject $hello(msg) in Vue, context and store.
    inject('openNewUrl', openNewUrl)
  }
}